function buildArticle(sections) {
  let html = "";

  sections.forEach(section => {
    switch (section.type) {
      case 'article_hero':
        html += buildArticleHero(section);
        break;
      case 'article-fifty-fifty':
        html += buildArticleFiftyFifty(section);
        break;
      case 'main-article':
        html += buildMainArticle(section);
        break;
      case 'article_2-3-up':
        html += buildArticle23Up(section);
        break;
      case 'article-fifty-fifty_content_row-01':
        html += buildArticleFiftyFiftyContentRow01(section);
        break;
      case 'article-fifty-fifty_content_row-02':
        html += buildArticleFiftyFiftyContentRow02(section);
        break;
      case 'article-fifty-fifty_content_row-03':
        html += buildArticleFiftyFiftyContentRow03(section);
        break;
      case 'article-related-products':
        html += buildArticleRelatedProducts(section);
        break;
      case 'article-image-banner':
        html += buildArticleImageBanner(section);
        break;
      case 'spacer':
        html += buildSpacer(section);
        break;
      case 'video':
        html += buildVideo(section);
        break;
      default:
        // Handle unknown section types
        html += `<div class="section-${section.type}">Unknown Section Type</div>`;
    }
  });

  return html;
}

// Placeholder functions for each section type (replace with actual implementation)
function buildArticleHero(section) {
  // Logic to build article_hero section
  let html = `<div class="article_hero">`;
  if (section.settings.icon === 'arrow-left') {
    html += `
      <a href="${section.settings.arrow_link}" class="mt-3 justify-center group focus-link uppercase focus-link--dark">
        <span class="icon">${renderIconArrowLeft()}</span>
        <span class="inline-block">Back to ${section.settings.arrow_link_text}</span>
      </a>
    `;
  }
  html += `</div>`;
  return html;
}

function renderIconArrowLeft() {
  // Example using an SVG string:
  return `
    <svg>
      <use xlink:href="#icon-arrow-left"></use>
    </svg>
  `;
}

function buildArticleFiftyFifty(section) {
  // Logic to build article-fifty-fifty section
  return `<div class="article-fifty-fifty"></div>`;
}

// ... (Implement other build functions for each section type) ...

function buildArticleVideo(section) {
  // Logic to build article-video section
  return `<div class="article-video"></div>`;
}

function buildSpacer(section) {
  // Logic to build spacer section
  return `<div class="spacer"></div>`;
}

// ... (Add more functions for other section types as needed) ...
